export default "__VITE_ASSET__CevhQjs1__"